// @flow

import * as React from 'react';

import { StaticAssetProvider } from '@zapier/common-components';

import Config from 'app/common/Config';

type Props = {
  children: React.Node,
};

export default (props: Props) => (
  <StaticAssetProvider {...props} staticAssetPath={Config.mediaUrl} />
);
